import * as React from 'react';
export const fingerprintSvg = React.forwardRef(function fingerprintSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.001 1.4a8.135 8.135 0 0 0-3.055.555.7.7 0 0 1-.492-1.31A9.53 9.53 0 0 1 8.001 0c1.607 0 2.692.325 3.545.645a.7.7 0 1 1-.492 1.31A8.124 8.124 0 0 0 8.001 1.4Zm5.265 4.695c-2.924-2.922-8.018-2.805-10.532.158a.7.7 0 1 1-1.068-.906c3.086-3.637 9.135-3.695 12.59-.242a.7.7 0 1 1-.99.99ZM2.69 7.768C3.709 5.965 5.783 4.9 8.24 4.9c3.032 0 5.74 2.257 5.74 5.5a2.14 2.14 0 0 1-2.14 2.14c-.387 0-.737-.083-1.044-.253a2.046 2.046 0 0 1-.697-.654c-.277-.408-.446-.927-.58-1.338l-.05-.155c-.162-.488-.303-.838-.514-1.079C8.783 8.865 8.528 8.7 8 8.7c-.785 0-1.232.27-1.493.612-.282.37-.429.929-.39 1.624.08 1.412.904 3.017 2.066 3.778a.7.7 0 0 1-.766 1.172c-1.588-1.04-2.597-3.083-2.698-4.872-.05-.905.126-1.833.675-2.551C5.962 7.718 6.852 7.3 8 7.3c.898 0 1.55.315 2.008.839.42.48.633 1.09.79 1.56l.05.15c.147.45.251.765.41.998a.653.653 0 0 0 .22.216.71.71 0 0 0 .362.077.74.74 0 0 0 .74-.74c0-2.364-1.97-4.1-4.34-4.1-2.068 0-3.613.885-4.333 2.157-.708 1.254-.716 3.067.675 5.155a.7.7 0 1 1-1.164.776c-1.609-2.412-1.76-4.799-.73-6.62ZM8 9.7a.7.7 0 0 1 .7.7c0 .56.273 1.18.776 1.79a6.341 6.341 0 0 0 1.852 1.492.7.7 0 1 1-.658 1.236 7.737 7.737 0 0 1-2.273-1.836c-.62-.751-1.097-1.68-1.097-2.682a.7.7 0 0 1 .7-.7Z',
    }),
  );
});
fingerprintSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var fingerprint = {
  category: 'icon',
  colorable: true,
  name: 'fingerprint',
  svg: fingerprintSvg,
};
